export default __webpack_public_path__ + "static/media/spray.8d081a29.mp3";